import React, { Fragment } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import BoardDetailContent from '../../components/BoardDetail/BoardDetailContent';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.svg';
import Hero3 from './Main';

const BoardDetail = () => {
    const { id } = useParams();

    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />
            <Hero3 />

            <BoardDetailContent id={id} />

            <Footer hclass={'footer-section section-padding'} />
            <Scrollbar />
        </Fragment>
    );
};

export default BoardDetail;
